(function (global) {
// Create a global object for our library
const DetectNewUser = {
// Function to check if it's the user's first visit or if it's a return visit
isNewUser: function () {
const userKey = 'hasVisitedBefore';  // Key to check user status in localStorage
const lastVisitKey = 'lastVisit';    // Key to store the last visit timestamp
const thirtyMinutes = 30 * 60 * 1000; // 30 minutes in milliseconds

const hasVisited = localStorage.getItem(userKey);
const lastVisit = localStorage.getItem(lastVisitKey);

// Get current time
const now = new Date().getTime();

// Check if last visit was within 30 minutes
if(now - parseInt(lastVisit, 10) >= thirtyMinutes) {
// User is returning within 30 minutes
return false;
}

// If it's a new visit or more than 30 minutes since the last visit
localStorage.setItem(userKey, 'true');  // Mark that the user has visited
localStorage.setItem(lastVisitKey, now.toString()); // Store current time as last visit
return true; // It's a new user or more than 30 minutes since last visit
},

// Optional: Clear the localStorage data for testing purposes
resetUserStatus: function () {
const userKey = 'hasVisitedBefore';
const lastVisitKey = 'lastVisit';
localStorage.removeItem(userKey); // Removes the key from localStorage
localStorage.removeItem(lastVisitKey); // Removes the last visit timestamp
}
};

global.DetectNewUser = DetectNewUser;
})(window);

